// extracted by mini-css-extract-plugin
export var banner = "_tj-0";
export var settingRow = "_tj-2";
export var titleIcon = "_tj-1";